export const FETCH_PAUSE_DATA_REQUEST = 'FETCH_PAUSE_DATA_REQUEST';
export const FETCH_PAUSE_DATA_SUCCESS = 'FETCH_PAUSE_DATA_SUCCESS';
export const FETCH_PAUSE_DATA_FAILURE = 'FETCH_PAUSE_DATA_FAILURE';